import React from 'react';
import { Users, BookOpen } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const TemplateList = ({ templates, selectedTemplate, onSelect }) => (
  <>
    {templates.map((template) => (
      <Card
        key={template.id}
        className={`p-4 cursor-pointer transition-colors ${
          selectedTemplate?.id === template.id
            ? 'border-2 border-slate-700 bg-stone-50'
            : 'border border-stone-200 hover:border-slate-400'
        }`}
        onClick={() => onSelect(template)}
        data-testid={`template-${template.id}`}
      >
        <h4 className="font-semibold text-stone-900 mb-1">{template.name}</h4>
        <p className="text-sm text-stone-600">{template.description}</p>
      </Card>
    ))}
  </>
);

export const TemplatePicker = ({ projectTemplates, essayTemplates, selectedTemplate, onSelect }) => (
  <Card className="p-6">
    <h3 className="text-xl font-serif font-normal text-stone-900 mb-4">Select Template</h3>
    <Tabs defaultValue="project">
      <TabsList className="mb-4">
        <TabsTrigger value="project">
          <Users className="h-4 w-4 mr-2" />
          Project-Based
        </TabsTrigger>
        <TabsTrigger value="essay">
          <BookOpen className="h-4 w-4 mr-2" />
          Argumentative Essay
        </TabsTrigger>
      </TabsList>
      <TabsContent value="project" className="space-y-3">
        <TemplateList templates={projectTemplates} selectedTemplate={selectedTemplate} onSelect={onSelect} />
      </TabsContent>
      <TabsContent value="essay" className="space-y-3">
        <TemplateList templates={essayTemplates} selectedTemplate={selectedTemplate} onSelect={onSelect} />
      </TabsContent>
    </Tabs>
  </Card>
);
